import React from "react";
import { usePopup, POPUP_LONG_TEXT } from "./PopupContext";

export function Fibonacci(n) {
  if (n === 0 || n === 1) {
    return n;
  }
  return Fibonacci(n - 1) + Fibonacci(n - 2);
}

export function next_combination(a, n) {
  let k = a.length;
  for (let i = k - 1; i >= 0; --i) {
    if (a[i] < n - k + i + 1) {
      ++a[i];
      for (let j = i + 1; j < k; ++j) {
        a[j] = a[j - 1] + 1;
      }
      return true;
    }
  }
  return false;
}

export function all_combinations(k, n) {
  let res = [];
  let a = Array(k)
    .fill()
    .map((e, i) => i + 1);
  let dop_a = Array(n)
    .fill()
    .map((e, i) => i + 1);
  dop_a = dop_a.filter((item) => !a.includes(item));
  res.push(a.slice());
  res.push(dop_a.slice());
  while (next_combination(a, n)) {
    let dop_a = Array(n)
      .fill()
      .map((e, i) => i + 1);
    dop_a = dop_a.filter((item) => !a.includes(item));
    res.push(a.slice());
    res.push(dop_a.slice());
  }
  return res;
}

export function calculate_position(score, squares, rows, ab) {
  let res = -999;
  for (let i in score) {
    if (score[i].squares === JSON.stringify(squares)) {
      res = score[i].win_a;
      break;
    }
  }
  return res;
}

export function calcRow(r, squares, rows, ab) {
  let sentence = "";
  let Nlines = 8;
  let y = r;

  if (!rows[y]) {
    for (let x = 0; x < Nlines; x++) {
      if (squares[x + 8 * y]) {
        if (x === y) {
          // Main diagonal
          if (squares[x + 8 * y] === "a") {
            sentence = "$a = not $a;";
          } else {
            sentence = "$b = not $b;";
          }
          break;
        } else {
          // Not main diagonal
          if (squares[x + 8 * y] === "a") {
            sentence = "if($a) goto L" + (x + 1) + ";";
          } else {
            sentence = "if($b) goto L" + (x + 1) + ";";
          }
          break;
        }
      }
    }
  }

  let empty = rows[r] ? "pass" : sentence;
  let strrow = "L" + (r + 1) + ":" + empty;
  return strrow;
}

export function calculateWinner(squares, rows, ab) {
  let trace = "TRACE\n" + "Ln: a-b\n" + "L0: 0-0\n";
  let trace_plus = "";
  let ny = rows.reduce((sum, current) => (current ? sum + 1 : sum), 0);
  let result = "";
  let Nlines = 8;
  let y = 0;
  let y1 = 0;
  let cycling = 0;
  let a = 0;
  let b = 0;
  let count = 0;

  while (y < Nlines && !cycling) {
    if (!rows[y]) {
      for (let x = 0; x < Nlines; x++) {
        if (squares[x + 8 * y]) {
          if (x === y) {
            // Main diagonal
            if (squares[x + 8 * y] === "a") {
              a = 1 - a;
            } else {
              b = 1 - b;
            }
            y++;
            y1 = y;
            trace += "L" + y1 + ": " + a + "-" + b + "\n";
            break;
          } else {
            // Not main diagonal
            if (
              (squares[x + 8 * y] === "a" && a === 1) ||
              (squares[x + 8 * y] === "b" && b === 1)
            ) {
              y = x;
              y1 = y;
              trace_plus = "L" + y1 + ": " + a + "-" + b + "\n";
              let re = new RegExp(trace_plus, "gi");

              count = 0;
              trace.replace(re, function () {
                count++;
                return trace_plus;
              });
              trace += "count = " + count + "\n";
              if (count > 0) {
                cycling = 1;
                trace += trace_plus + " cycling" + "\n\n";
                break;
              } else {
                trace += "L" + y1 + ": " + a + "-" + b + "\n";
                break;
              }
            } else {
              y++;
              y1 = y;
              trace += "L" + y1 + ": " + a + "-" + b + "\n";
              break;
            }
          }
        }
      }
    } else {
      y++;
      y1 = y;
      trace += "L" + y1 + ": " + a + "-" + b + "\n";
    }
  }

  if (cycling) {
    result = "cycling\n";
    result += (ab ? "a" : "b") + " win\n";
    result += "GAME OVER\n";
  } else if (y === Nlines && ny === 0) {
    if (a === b) {
      result = "a win\n";
      result += "GAME OVER\n";
    } else {
      result = "b win\n";
      result += "GAME OVER\n";
    }
  } else {
    result = "now a=" + a + " and b=" + b + "\n";
  }

  return trace + result;
}

export function who_win(squares, rows, ab) {
  let trace = "TRACE\n" + "Ln: a-b\n" + "L0: 0-0\n";
  let trace_plus = "";
  let res = { cycling: 0, abwin: "a", gameover: 0 };
  let ny = rows.reduce((sum, current) => (current ? sum + 1 : sum), 0);
  let result = "";
  let Nlines = 8;
  let y = 0;
  let y1 = 0;
  let cycling = 0;
  let a = 0;
  let b = 0;
  let count = 0;

  while (y < Nlines && !cycling) {
    if (!rows[y]) {
      for (let x = 0; x < Nlines; x++) {
        if (squares[x + 8 * y]) {
          if (x === y) {
            // Main diagonal
            if (squares[x + 8 * y] === "a") {
              a = 1 - a;
            } else {
              b = 1 - b;
            }
            y++;
            y1 = y;
            trace += "L" + y1 + ": " + a + "-" + b + "\n";
            break;
          } else {
            // Not main diagonal
            if (
              (squares[x + 8 * y] === "a" && a === 1) ||
              (squares[x + 8 * y] === "b" && b === 1)
            ) {
              y = x;
              y1 = y;
              trace_plus = "L" + y1 + ": " + a + "-" + b + "\n";
              let re = new RegExp(trace_plus, "gi");

              count = 0;
              trace.replace(re, function () {
                count++;
                return trace_plus;
              });
              trace += "count = " + count + "\n";
              if (count > 0) {
                cycling = 1;
                trace += trace_plus + " cycling" + "\n\n";
                break;
              } else {
                trace += "L" + y1 + ": " + a + "-" + b + "\n";
                break;
              }
            } else {
              y++;
              y1 = y;
              trace += "L" + y1 + ": " + a + "-" + b + "\n";
              break;
            }
          }
        }
      }
    } else {
      y++;
      y1 = y;
      trace += "L" + y1 + ": " + a + "-" + b + "\n";
    }
  }

  if (cycling) {
    result = "cycling\n";
    res.cycling = 1;
    result += (ab ? "a" : "b") + " win\n";
    res.abwin = ab ? "a" : "b";
    result += "GAME OVER\n";
    res.gameover = 1;
  } else if (y === Nlines && ny === 0) {
    if (a === b) {
      result = "a win\n";
      res.abwin = "a";
      result += "GAME OVER\n";
      res.gameover = 1;
    } else {
      result = "b win\n";
      res.abwin = "b";
      result += "GAME OVER\n";
      res.gameover = 1;
    }
  } else {
    result = "now a=" + a + " and b=" + b + "\n";
    res.abwin = a === b ? "a" : "b";
  }

  return res;
}

const PopupTrigger = () => {
  const { triggerPopup } = usePopup();

  const content = (
    <div>
      {POPUP_LONG_TEXT.split("\n\n").map((para, i) => (
        <p key={i}>{para}</p>
      ))}
    </div>
  );

  return (
    <button img className="btn" onClick={() => triggerPopup({ content })}>
      Info
    </button>
  );
};

export default PopupTrigger;
